import { Component, OnInit } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { Case } from '../../_types/case';
import { CasesStatesService } from '../../_services/cases-states.service';
import { CasesService } from '../../_services/cases.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { MessageService } from 'primeng/api';
import { CaseState } from '../../_types/case-state';
import { filter, first, firstValueFrom } from 'rxjs';
import { AddressesService } from 'src/app/modules/common/_services/addresses.service';
import { Address } from 'src/app/modules/common/_types/address';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation, HasFilter, NotFilter, OrFilter } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { JobsService } from '../../_services/jobs.service';
import { HttpClient } from '@angular/common/http';
import { ResponseCollection } from 'src/app/core/jsonapi/responses/response-collection';
import { environment } from 'src/environment/environment';
import { Capability } from 'src/app/modules/common/_types/capability';
import { CapabilitiesService } from 'src/app/modules/common/_services/capabilities.service';
import { TransactionsService } from 'src/app/modules/transactions/_services/transactions.service';
import { ProviderCasesService } from 'src/app/modules/providers/_services/providers-cases.service';
import { CasesServicesTypesService } from '../../_services/cases-services-types.service';
import { CasesLogsService } from '../../_services/cases-logs.service';

@Component({
    selector: 'app-case-state-change',
    templateUrl: './case-state-change.component.html',
    styleUrls: ['./case-state-change.component.scss'],
    standalone: false
})
export class CaseStateChangeComponent implements OnInit {

  public caseStateConfiguration:any = {};
  public caseStateMetadata:any = {};
  public allStates: CaseState[] = [];
  public states: CaseState[] = [];
  public case:Case = new Case();
  private originalCaseState?: CaseState | null = null;
  private selectedCaseState?: CaseState | null = null;
  public showReopenCheck: boolean = false;
  public error_message: string = "";
  //ITSM #1838992: mensaje de rentabilidad insuficiente. Va aparte de error_message porque, a diferencia
  //de las demás validaciones de cierre, no bloquea el botón "Guardar": al guardar, el expediente se
  //redirige a "Rev económica" en vez de finalizar (ver save()).
  public profitability_message: string = "";
  public isFinal: boolean = true;
  public capabilities: Capability[] = [];
  private caseModeCode: string | null = null;
  constructor(
    private _http: HttpClient,
    private casesService: CasesService,
    private casesStatesService: CasesStatesService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private jobsService: JobsService,
    private messageService: MessageService,
    private capabilitiesService: CapabilitiesService,
    private transactionService: TransactionsService,
    private providerCasesService: ProviderCasesService,
    private casesServicesTypesService: CasesServicesTypesService,
    private casesLogsService: CasesLogsService
  ) {
  }

  async ngOnInit() {
    this.isFinal = this.config.data.isFinal ?? true;
    this.caseModeCode = this.config.data.caseModeCode ?? null;
    await this.loadCaseStates();
    this.loadCapabilites();
    this.load(this.config.data.id);
  }

  async loadCaseStates() {
    const filters: { [key: string]: any } = { }
    if(this.caseModeCode!=null){
      //filtro por relacion: pendiente de verificar contra la API que JsonApiDotNetCore acepte la cadena caseMode.code dentro de has()
      filters["caseMode"] = new HasFilter('caseModes',
        new Filter(FilterOperation.equals, 'caseMode.code', '', this.caseModeCode));
    }
    let params: IParamsCollection = {
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.casesStatesService.all(params));
    this.allStates = response.data;
    this.states = this.allStates.filter((state: CaseState) => state.isFinal == this.isFinal);
  }

  async loadCapabilites() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: { size: 500 }
    };
    let response = await firstValueFrom(this.capabilitiesService.all(params));
    this.capabilities = response.data;
  }

  async load(id: string) {
    let params: IParamsCollection = {
      include: ['caseState']
    };
    this.case = await firstValueFrom(this.casesService.get(id, params));

    this.originalCaseState = this.allStates.find((state: any) => state.id == this.case?.caseStateId);

    //si tenemos estado, lo marcamos
    if(this.config.data.selectedCaseStateId!=null){
      this.case.caseStateId = this.config.data.selectedCaseStateId;
      setTimeout(() => this.onChangeCaseState(), 500);
    }
  }
  

  onChangeCaseState(){
    this.error_message="";
    this.profitability_message="";
    var caseState = this.states.find((state: any) => state.id == this.case?.caseStateId);
    this.selectedCaseState = caseState;
    this.checkRequireReopenCheck();
    this.caseStateConfiguration = null;
    if(caseState?.configuration!=null && caseState?.configuration!='') this.caseStateConfiguration = JSON.parse(caseState.configuration);

    //si el codigo es "cancel" comprobamos si tiene algun job cnon trasactionId, pero si es de tipo close también se comprueban cosas
    // , si es así no le se puede anular porque tiene trabajos facturados.
    //if(this.caseStateConfiguration?.code !== "undefined" && this.caseStateConfiguration?.code === "canceled"){
      this.loadJobs(this.selectedCaseState?.code);
    //}

  }

  checkShowCondition(field:any){
    let ret = true;
    let condition = field?.showCondition;
    if(condition!=null && condition!=''){
      try{
        // Evaluamos la condición como una expresión booleana
        ret = eval(condition);
      }catch(e){
        console.error("Error al evaluar la condición de visibilidad: ", condition, e);
        ret = false;
      }
    }
    return ret;
  }

  async loadJobs(type: string="CANCELED") {

    //ITSM #1838992: la rentabilidad se comprueba antes que el resto de validaciones de cierre. Si no la
    //cumple, se muestra solo ese mensaje (no las demás preguntas/validaciones): al pulsar "Guardar" el
    //expediente pasa a "Rev económica" en vez de finalizar (ver save()).
    this.profitability_message = "";
    if(type == "CLOSED" && !this.case.profitReviewAcknowledged){
      try{
        const profitability = await firstValueFrom(this.casesService.getProfitability(this.case.id!));
        if(profitability.isBelowMinimum){
          this.profitability_message = "Rentabilidad menor a la permitida. Se informará al responsable económico para su revisión antes de poder finalizar el expediente.";
          this.error_message = "";
          return;
        }
      }catch(e){
        console.error("Error al comprobar la rentabilidad del expediente", e);
      }
    }

    let params: IParamsCollection = {
      page: {size: 0}
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId",'',this.case.id),
      caseService: new OrFilter([
        new Filter(FilterOperation.equals, "caseService.deleted", '', false),
        new Filter(FilterOperation.equals, "caseServiceId", '', null, true)
      ]),
      transactionId: new NotFilter(FilterOperation.equals, "transactionId",'',null, true)
    };
    if(type == "CLOSED"){
      //Si quieren cerrar el expediente, se comprubea que no tenga trabajos marcados como facturables y revisados pero SIN FACTURA ASOCIADA.
      filters["isBillable"] = new Filter(FilterOperation.equals, "isBillable",'',true);
      filters["isReview"] = new Filter(FilterOperation.equals, "isReview",'',true);
      filters["transactionId"] = new Filter(FilterOperation.equals, "transactionId",'',null, true);
      filters["isForCompany"] = new Filter(FilterOperation.equals, "isForCompany",'', true);
    }

    params.filter = FilterBuilder.fromObject(filters).build();      
    let response = await firstValueFrom(this.jobsService.all(params));
    if(response.data.length>0 && type == "CANCELED"){
      this.error_message = "No se puede cerrar el expediente como 'Anulado' porque tiene trabajos facturados.";
    }else if(response.data.length>0 && type == "CLOSED"){
      this.error_message = "No se puede cerrar el expediente como 'Finalizado' porque tiene trabajos revisados y facturables pero sin la factura asociada.";
    }
    else{this.error_message = "";}

    if(type == "CLOSED"){
      
      let paramsTransaction: IParamsCollection = {  
        page: {size: 0},
        include: ["transactionState", "transactionType"]
      }
      let filtersTransaction: any = {
        caseId: new Filter(FilterOperation.equals, "caseId",'',this.case.id),  
        transactionTypeCode: new Filter(FilterOperation.any, "transactionType.code", '', ["purchase_order", "outgoing_budget", "company_outgoing_budget", "affected_outgoing_budget", "ingoing_budget_worker"])
      }
      paramsTransaction.filter = FilterBuilder.fromObject(filtersTransaction).build();
      let responseTransaction = await firstValueFrom(this.transactionService.all(paramsTransaction))
      
      //Se comprueba que los presupeustos estén en estado final, si no es así no se puede cerrar el expediente
      let budgetsTransactions = responseTransaction.data.filter(m => m.transactionType.code != "purchase_order");
      if(budgetsTransactions.length > 0){
        var transactionBudgets = budgetsTransactions.filter(m => m.transactionState.isFinal == false);
        if(transactionBudgets.length>0){
          this.error_message += "<br><br>No se puede cerrar el expediente porque hay 'Presupuestos' que no están en un estado final."
          transactionBudgets.forEach((transaction: any) => {  
            this.error_message += "<br> - Presupuesto: " + transaction.code + " - Estado: " + transaction.transactionState.name;
          });
        }
      }

      //Comprobamos que si tiene un transaction de SOLICITUD DE COMPRA
      //1) debe marcarlo como finalizado o anulado.
      //2) si tiene, tiene que tener al menos una liquidación a compañía y otra a proveedor.
      let purchasesOrdersTransactions = responseTransaction.data.filter(m => m.transactionType?.code == "purchase_order");
      if(purchasesOrdersTransactions.length > 0){
        var transactionPurchase = purchasesOrdersTransactions.filter(m => m.transactionState.code!="annuled" && m.transactionState.code!="completed");
  
        if(transactionPurchase.length>0){
          this.error_message += "<br><br>No se puede cerrar el expediente porque hay 'Solicitudes de compra' sin finalizar o anular."
        }
        
        var markAsCompleted = purchasesOrdersTransactions.filter(m => m.transactionState.code != "annuled");

        if(markAsCompleted.length > 0){
          //Si existe en cualqiuer estado que no sea anulado, se comprueba si no hay linea de liquidación a proveedor & compañía (debe existir linea en AMBOS) 
           let filters: any = {      
            caseId: new Filter(FilterOperation.equals, "caseId",'',this.case.id),
            //transactionId: new NotFilter(FilterOperation.equals, "transactionId",'',null, true),
            providerId: new NotFilter(FilterOperation.equals, "providerId", '', null, true)
          };
          params.filter = FilterBuilder.fromObject(filters).build();      
          let response = await firstValueFrom(this.jobsService.all(params));
          var jobsFromProviders = response.data;
          if(jobsFromProviders.length == 0){
            this.error_message += "<br><br>No se puede cerrar el expediente porque hay 'Solicitudes de compra' sin líneas de liquidación asociada."
          } else{
            //miramos si hay liquidaciones por cada proveedor.
            const providerIds = [...new Set(markAsCompleted.map((t: any) => t.thirdPartyId).filter((id: any) => id != null))];
            for (const providerId of providerIds) {
              // Comprobamos si existe providerCase y si companyJobsNoRequired está a true (en ese caso se salta la validación)
              let providerCaseFilters: any = {
                caseId: new Filter(FilterOperation.equals, "caseId", '', this.case.id),
                providerId: new Filter(FilterOperation.equals, "providerId", '', providerId)
              };
              let providerCaseParams: IParamsCollection = { page: { size: 1 } };
              providerCaseParams.filter = FilterBuilder.fromObject(providerCaseFilters).build();
              let providerCaseResponse = await firstValueFrom(this.providerCasesService.all(providerCaseParams));
              let providerCase = providerCaseResponse.data.length > 0 ? providerCaseResponse.data[0] : null;

              if (providerCase?.companyJobsNoRequired === true) continue;

              const jobsForProvider = jobsFromProviders.filter((j: any) => j.providerId === providerId);
              const hasForCompany = jobsForProvider.some((j: any) => j.isForCompany === true);
              const hasForProvider = jobsForProvider.some((j: any) => j.isForCompany === false);
              if (!hasForCompany || !hasForProvider) {
                this.error_message += "<br><br>No se puede cerrar el expediente porque hay 'Solicitudes de compra' sin líneas de liquidación a compañía y a proveedor para todos los proveedores.";
                break;
              }
            }
          }
        }  
      }

      await this.checkHarmonyCaseLog();

    }

  }

  /**
   * ITSM #1839065: un expediente de "Alicatado sin armonía" (tipo de servicio TILING) no puede
   * finalizarse sin haber registrado la comunicación "Rotura de armonía estética" (tipo de evento
   * HARMONY), que es donde el tramitador deja la cobertura y el motivo de la rotura.
   *
   * Los dos catálogos se buscan por código, no por nombre: el nombre lo edita el cliente desde la
   * pantalla de configuración, el código lo fija la migración (ver
   * service_type_alicatado_sin_armonia y case_log_type_rotura_armonia_estetica).
   */
  private async checkHarmonyCaseLog() {
    let serviceTypeParams: IParamsCollection = { page: { size: 1 } };
    serviceTypeParams.filter = FilterBuilder.fromObject({
      caseId: new Filter(FilterOperation.equals, "caseId", '', this.case.id),
      serviceTypeCode: new Filter(FilterOperation.equals, "serviceType.code", '', "TILING")
    }).build();
    let serviceTypes = await firstValueFrom(this.casesServicesTypesService.all(serviceTypeParams));
    if(serviceTypes.data.length == 0) return;

    let caseLogParams: IParamsCollection = { page: { size: 1 } };
    caseLogParams.filter = FilterBuilder.fromObject({
      caseId: new Filter(FilterOperation.equals, "caseId", '', this.case.id),
      caseLogTypeCode: new Filter(FilterOperation.equals, "caseLogType.code", '', "HARMONY")
    }).build();
    let caseLogs = await firstValueFrom(this.casesLogsService.all(caseLogParams));
    if(caseLogs.data.length == 0){
      if(this.error_message != '') this.error_message += "<br><br>";
      this.error_message += "No se puede cerrar el expediente ya que siendo alicatado sin armonía no se ha añadido la comunicación correspondiente.";
    }
  }

  checkRequireReopenCheck(){
    let ret = false;
    if(this.originalCaseState!=null && this.selectedCaseState!=null && !this.selectedCaseState?.isFinal && this.originalCaseState?.isFinal){
      ret = true;
    }
    this.showReopenCheck = ret;
  }

  async save() {
    //ITSM #1838992: no se puede finalizar un expediente con rentabilidad por debajo del mínimo del
    //contrato salvo que ya se haya marcado la revisión ("Ok, revisado"). profitability_message ya lo ha
    //calculado loadJobs(), que es donde se comprueba antes que el resto de validaciones de cierre. Va lo
    //primero de save(), antes de validar los campos del formulario del estado "Finalizado": esos campos no
    //aplican, porque el expediente no va a llegar a ese estado, sino a "Rev económica".
    //IMPORTANTE: no tocamos aquí this.case.caseStateId (se deja el estado "Finalizado" que el tramitador
    //seleccionó) ni revisionDate: es el backend (CaseChangeTracking.CheckProfitReviewOnStateChange) quien
    //detecta el intento de pasar a CLOSED, hace el redirect a "Rev económica", pone la fecha de revisión a
    //hoy y crea las notificaciones. Si lo redirigiéramos aquí en el cliente, el backend recibiría
    //directamente CaseStateId=ECONOMIC_REVIEW (no CLOSED) y su gate nunca se dispararía: nada de
    //notificaciones ni trazabilidad.
    if(this.profitability_message != ''){
      await firstValueFrom(this.casesService.save(this.case!));
      this.messageService.add({severity:'warn', summary: 'Rentabilidad menor a la permitida', detail: 'El expediente ha pasado a "Rev económica" para su revisión antes de poder finalizarse.'});
      this.dynamicDialogRef.close({ skipRevisionDateModal: true });
      return;
    }

    //revisamo si todos los campos requeridos estan cumplimentados en el metadata
    var errors = "";
    for(let field of this.caseStateConfiguration?.fields || []){
      if(this.checkShowCondition(field)){
        let value = this.caseStateMetadata[field.code];
        if(field.required && field.type!='select-capability' && (value==null || String(value).trim()=='') ){
          errors += ` - El campo '${field.label}' es obligatorio.\n`;
        }else if(field.required && field.type=='select-capability' && (this.case.pendingCapabilityId==null || this.case.pendingCapabilityId=='') ){
          errors += ` - El campo '${field.label}' es obligatorio.\n`;
        }
        if(field.type=='select-capability' && this.case.pendingCapabilityId!=null){
          this.caseStateMetadata[field.code] = this.case.pendingCapabilityId;
        }
      }
    }
    if(errors!=''){
      this.messageService.add({severity:'error', summary: 'Error', detail: 'Existen errores en el formulario:\n'+errors});
      return;
    }

    if(this.caseStateMetadata!=null){
      this.case!.caseStateMetadata = JSON.stringify(this.caseStateMetadata);
    }else{
      this.case!.caseStateMetadata = "{}";
    }

    await firstValueFrom(this.casesService.save(this.case!));
    this.dynamicDialogRef.close();
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

}
